export const GET_ALL_HOSPITALS = "GET_ALL_HOSPITALS";
export const GET_DEPARTMENT_BY_HOSPITAL_ID = "GET_DEPARTMENT_BY_HOSPITAL_ID";
